import {Event} from "ts-typed-events";
import {UserSession} from "../data/auth/UserSession";
import {UserPreferences} from "../data/preferences/UserPreferences";
import {EnvironmentStage} from "../data/EnvironmentStage";

export const GlobalEvents = {
	userLoggedOn: new Event<UserLoggedOn>(),
	userPreferencesChanged: new Event<UserPreferencesChange>(),
	targetStageChanged: new Event<TargetStageChange>(),
};

export class UserLoggedOn {
	constructor(
		readonly userSession: UserSession,
	) {
	}
}

export class UserPreferencesChange {
	constructor(
		readonly oldValue: UserPreferences,
		readonly userPreferences: UserPreferences,
	) {
	}
}

export class TargetStageChange {
	constructor(
		readonly oldValue: EnvironmentStage | null,
		readonly targetStage: EnvironmentStage | null,
	) {
	}
}
